<template>
  <div class="user-activity">
    <v-container>
      <h2 class="mb-3">User Attendance</h2>
      <v-card class="px-6 pb-0">
        <v-row>
          <v-col md="4">
            <v-autocomplete
              label="Select User"
              :items="userList"
              v-model="user_id"
              item-text="full_name"
              item-value="user_id"
              v-on:change="onSelectUser"
            ></v-autocomplete>
            <!-- <v-text-field
              hide-details
              label="Find a user"
              prepend-icon="mdi-magnify"
              single-line
            ></v-text-field> -->
          </v-col>
          <v-col md="4" class="pb-0">
            <v-menu
              ref="menu_start"
              v-model="menu_start"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateStartFormatted"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_start"
                @change="onStartDateChange()"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="4" class="pb-0">
            <v-menu
              ref="menu_end"
              v-model="menu_end"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateEndFormatted"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_end"
                @change="onEndDateChange()"
                no-title
                scrollable
                :min="date_start"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>

      <v-row>
        <v-col class="pt-0" md="6">
          <GmapMap
            class="mt-3"
            :center="{ lat: -6.266202, lng: 106.818325 }"
            :zoom="12"
            map-type-id="terrain"
            style="height: 100%"
          >
            <GmapCluster>
              <GmapMarker
                v-for="m in activities"
                :key="m.type + m.timestamp + m.user_name"
                :position="{ lat: m.latitude, lng: m.longitude }"
                :clickable="true"
                :draggable="true"
                @click="toggleInfo(m, m.user_name + m.timestamp)"
              />
            </GmapCluster>
            <GmapInfoWindow
              :options="info_options"
              :position="info_position"
              :opened="info_opened"
              @closeclick="info_opened = false"
              >{{ info_content }}</GmapInfoWindow
            >
          </GmapMap>
        </v-col>
        <v-col md="6">
          <v-card height="800" max-height="100%" class="pb-0 overflow-y-auto">
            <v-simple-table v-if="!loading">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Type</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Time</th>
                    <th class="text-center">Schedule</th>
                    <th class="text-center">Location</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in activities"
                    :key="item.name"
                    @click="focusUser(item)"
                  >
                    <td v-if="item.type === 'in'" class="text-center">
                      <v-icon color="success">mdi-location-enter</v-icon>
                    </td>
                    <td v-if="item.type === 'out'" class="text-center">
                      <v-icon color="error">mdi-location-exit</v-icon>
                    </td>
                    <td class="text-center">{{ toDate(item.timestamp) }}</td>
                    <td class="text-center">
                      {{ toHours(item.group_timezone, item.timestamp) }}
                    </td>
                    <td class="text-center">
                      <v-chip
                        v-bind:class="checkReasonColor(item.reason)"
                        class="caption"
                        >{{ item.reason }}</v-chip
                      >
                    </td>
                    <td class="text-center">
                      <v-chip
                        v-bind:class="checkNoteColor(item.note)"
                        class="caption"
                        >{{ item.note }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <v-skeleton-loader
              class="mx-auto"
              type="table-tbody"
              v-if="loading"
            ></v-skeleton-loader> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import firebase from "firebase";
import moment from "moment";
import mt from "moment-timezone";
import ENV from './../store/modules/environtment'
export default {
  name: "user-activity",
  data() {
    return {
      userList: [],
      user_id: "",
      activities: [],
      date: new Date().toISOString().substr(0, 10),
      date_start: null,
      date_end: null,
      menu_start: false,
      menu_end: false,
      loading: true,
      info_options: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      info_position: null,
      info_opened: false,
      info_content: null,
      group_id: this.$store.state.group_id,
      company_id: this.$store.state.company,
    };
  },
  computed: {
    dateStartFormatted() {
      return this.date_start
        ? moment(this.date_start, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")
        : "";
    },
    dateEndFormatted() {
      return this.date_end
        ? moment(this.date_end, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")
        : "";
    },
  },
  methods: {
    focusUser(user) {
      this.mapCenter = {
        lat: parseFloat(user.latitude),
        lng: parseFloat(user.longitude),
      };
      this.zoomLevel = 18;
      this.toggleInfo(user, user.user_name + user.timestamp);
    },
    toDate(time) {
      return moment(time).format("DD-MM-YYYY");
    },
    convertDate(time) {
      let convert = time.toString().split(" ");
      let hour = convert[4];
      return hour;
    },
    toHours(zone, time) {
      let utc = new Date(time).toUTCString();
      let tmp = "";
      if (zone === 7) {
        tmp = mt.tz(utc, "Asia/Jakarta");
      } else if (zone === 8) {
        tmp = mt.tz(utc, "Asia/Makassar");
      } else if (zone === 9) {
        tmp = mt.tz(utc, "Asia/Jayapura");
      }
      return this.convertDate(tmp);
    },
    onStartDateChange() {
      const diff = moment(this.date_end).diff(this.start_date, 'days')
      if (diff < 0) this.date_end = this.start_date
      this.menu_start = false;
      const date_unix = {
        start: moment(this.date_start).format("x"),
        end: moment(this.date_end)
          .add(1, "d")
          .subtract(1, "s")
          .format("x"),
      };
      this.fetchActivities(date_unix);
    },
    onEndDateChange() {
      this.menu_end = false;
      const date_unix = {
        start: moment(this.date_start).format("x"),
        end: moment(this.date_end)
          .add(1, "d")
          .subtract(1, "s")
          .format("x"),
      };
      this.fetchActivities(date_unix);
    },
    onSelectUser() {
      const date_unix = {
        start: moment(this.date_start).format("x"),
        end: moment(this.date_end)
          .add(1, "d")
          .subtract(1, "s")
          .format("x"),
      };
      this.fetchActivities(date_unix);
    },
    toggleInfo(marker, key) {
      this.info_position = { lat: marker.latitude, lng: marker.longitude };
      this.info_content =
        this.toHours(marker.group_timezone, marker.timestamp) +
        " " +
        marker.user_name +
        " (" +
        marker.type +
        ")";
      if (this.info_current_key == key) {
        this.info_opened = !this.info_opened;
      } else {
        this.info_opened = true;
        this.info_current_key = key;
      }
    },
    checkReasonColor(reason) {
      if (reason === "-") {
        return;
      }
      if (reason === "On-Time") {
        return "success";
      } else {
        if (reason === "In-Tolerance") {
          return "warning";
        } else {
          return "error";
        }
      }
    },
    checkNoteColor(note) {
      if (note === "In-Area") {
        return "success";
      } else {
        if (note === "GPS Error" || note === "Meeting" || note === "Work From Home") {
          return "warning";
        } else {
          return "error";
        }
      }
    },
    fetchActivities(date) {
      this.loading = true;
      firebase
        .firestore()
        .collection(ENV.firebase.attendance)
        .where("user_id", "==", this.user_id)
        .where("timestamp", ">", Number(date.start))
        .where("timestamp", "<", Number(date.end))
        .orderBy("timestamp", "desc")
        .get()
        .then((snapshot) => {
          this.activities = [];
          snapshot.forEach((doc) => {
            let attendance = doc.data();
            attendance.id = doc.id;
            this.activities.push(attendance);
          });
          this.loading = false;
        });
    },
    fetchUserList() {
      let role = this.$store.state.role;
      const pattern = /^([aA]dmin.)((?!\.)[\w-_.]*[^.])(@appsensi+)(\.\w+(\.\w+)?[^.\W])$/
      if (role === 0 || role === 2) {
        firebase
          .firestore()
          .collection(ENV.firebase.user)
          .where("company_id", "==", this.company_id)
          .orderBy("full_name", "asc")
          .get()
          .then((snapshot) => {
            this.userList = [];
            snapshot.forEach((doc) => {
              let user = doc.data();
              if (!pattern.test(user.email)) {
                this.userList.push(user);
              }
            });
          });
      } else if (role === 3 || role === 4) {
        firebase
          .firestore()
          .collection(ENV.firebase.user)
          .where("group_id", "==", this.group_id)
          .orderBy("full_name", "asc")
          .get()
          .then((snapshot) => {
            this.userList = [];
            snapshot.forEach((doc) => {
              let user = doc.data();
              if (!pattern.test(user.email)) {
                this.userList.push(user);
              }
            });
          });
      }
    },
  },
  created() {
    this.date_start = moment(this.date).format("YYYY-MM-DD");
    this.date_end = moment(this.date).format("YYYY-MM-DD");
    this.fetchUserList();
  },
};
</script>
